import React, { useEffect, useState } from 'react'
import { Tab, useMediaQuery, useTheme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'

const useStyles = makeStyles()(theme => ({
  tabPanelRoot: {
    padding: 0,
    paddingTop: theme.spacing(2),
    '& .MuiTabPanel-root': {
      padding: 0,
    },
  },
  tabRoot: {
    margin: 0,
  },
}))

export interface TabsProps {
  tabs: { name: string; content: React.ReactNode; onSelect?: () => void }[]
  fullWidth?: boolean
  activeTabNumber?: number
  className?: string
  updateOnActiveNumberChange?: boolean
}

const Tabs: React.VFC<TabsProps> = ({ tabs, className, fullWidth = true, activeTabNumber = 1, updateOnActiveNumberChange = false }) => {
  const { classes, cx } = useStyles()
  const [value, setValue] = useState(`${activeTabNumber}`)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))

  const handleChange = (_event: React.SyntheticEvent<Element, Event>, value: string): void => {
    setValue(value)
    tabs[parseInt(value) - 1].onSelect?.()
  }

  useEffect(() => {
    if (updateOnActiveNumberChange) setValue(`${activeTabNumber}`)
  }, [activeTabNumber, updateOnActiveNumberChange])

  return (
    <TabContext value={value}>
      {!updateOnActiveNumberChange && (
        <TabList
          onChange={handleChange}
          aria-label="tabs"
          allowScrollButtonsMobile
          variant={isMobile || fullWidth === false ? 'scrollable' : 'fullWidth'}
          classes={fullWidth ? { root: cx(classes.tabRoot, className) } : { root: className }}
          scrollButtons="auto"
          role="tab"
        >
          {tabs.map((tab, index) => (
            <Tab key={index} wrapped tabIndex={index} label={tab.name} value={`${index + 1}`} classes={fullWidth ? { root: classes.tabRoot } : {}} />
          ))}
        </TabList>
      )}
      {tabs.map((tab, index) => (
        <TabPanel key={index} value={`${index + 1}`} classes={fullWidth ? { root: classes.tabPanelRoot } : {}}>
          {tab.content}
        </TabPanel>
      ))}
    </TabContext>
  )
}

export default Tabs
